import type { AccountDeletionSummary, AccountLifecycleStatus } from '@/shared/model/types/accountDeletion';
import { accountLifecycleStatusLabels } from '@/shared/constants/accountDeletion';
import { StatusBadge } from '@/shared/ui/StatusBadge/StatusBadge';
import s from './AccountStatusCell.module.scss';

interface AccountStatusCellProps {
  status?: AccountLifecycleStatus;
  isActive: boolean;
  deletion?: AccountDeletionSummary | null;
  variant?: 'badge' | 'remaining';
}

const getStatusView = (status: AccountLifecycleStatus, isActive: boolean) => {
  if (status === 'pending_deletion') {
    return { label: accountLifecycleStatusLabels.pending_deletion, tone: 'orange' as const };
  }
  if (status === 'deleted') {
    return { label: accountLifecycleStatusLabels.deleted, tone: 'red' as const };
  }
  if (!isActive) {
    return { label: 'Заблокирован', tone: 'gray' as const };
  }
  return { label: accountLifecycleStatusLabels.active, tone: 'green' as const };
};

const getRemainingLabel = (deletion?: AccountDeletionSummary | null): string => {
  if (deletion?.remainingDays === null || deletion?.remainingDays === undefined) return 'Ожидает удаления';
  return Number(deletion.remainingDays) > 0 ? `До удаления: ${deletion.remainingDays} дн.` : 'Срок удаления наступил';
};

export const AccountStatusCell = ({
  status = 'active',
  isActive,
  deletion,
  variant = 'badge',
}: AccountStatusCellProps) => {
  if (variant === 'remaining') {
    return status === 'pending_deletion' ? (
      <span className={s.remainingOnly}>{getRemainingLabel(deletion)}</span>
    ) : null;
  }

  const statusView = getStatusView(status, isActive);

  return (
    <div className={s.root}>
      <StatusBadge tone={statusView.tone}>{statusView.label}</StatusBadge>
      {status === 'pending_deletion' && deletion ? (
        <span className={s.remaining}>
          {deletion.remainingDays !== null && deletion.remainingDays !== undefined
            ? Number(deletion.remainingDays) > 0
              ? `Осталось: ${deletion.remainingDays} дн.`
              : 'Срок истёк'
            : 'Осталось: —'}
        </span>
      ) : null}
    </div>
  );
};
